import { createApp } from 'vue'

import App from './App.vue'
import router from './router'
import store from './store'
import { setSession, getSession } from '@/util'
import './assets/css/index.css'
import 'lib-flexible/flexible'

import 'vant/lib/index.css' // 全局引入样式
let app = createApp(App)
import {
  Tabbar,
  TabbarItem,
  Grid,
  GridItem,
  Swipe,
  SwipeItem,
  ImagePreview,
  Cell,
  CellGroup,
  Popup,
  Icon,
  Col,
  Row,
  Picker,
  Card,
  Search,
  Divider,
  Badge,
  Button,
  Overlay,
  ActionBar,
  ActionBarIcon,
  ActionBarButton,
  ActionSheet,
  Collapse,
  CollapseItem,
  Step,
  Steps,
  Dialog,
  Stepper,
  Toast,
  DatetimePicker,
  Switch,
  Calendar,
  SwipeCell,
  Checkbox,
  CheckboxGroup,
  Image as VanImage,
  Lazyload,
  Loading,
  Tab,
  Tabs,
  Tag,
  CountDown,
  List,
  Notify,
  RadioGroup,
  Radio,
  Form,
  Field,
  DropdownMenu,
  DropdownItem,
  AddressList,
  NavBar,
  Skeleton
} from 'vant'

app
  .use(Tabbar)
  .use(TabbarItem)
  .use(Grid)
  .use(GridItem)
  .use(Swipe)
  .use(SwipeItem)
  .use(ImagePreview)
  .use(Cell)
  .use(CellGroup)
  .use(Form)
  .use(Field)
  .use(Popup)
  .use(Icon)
  .use(Col)
  .use(Row)
  .use(Divider)
  .use(Badge)
  .use(Button)
  .use(Overlay)
  .use(ActionBar)
  .use(ActionBarIcon)
  .use(ActionBarButton)
  .use(Picker)
  .use(Card)
  .use(ActionSheet)
  .use(Collapse)
  .use(CollapseItem)
  .use(Step)
  .use(Steps)
  .use(Stepper)
  .use(Dialog)
  .use(Toast)
  .use(Calendar)
  .use(DatetimePicker)
  .use(Switch)
  .use(SwipeCell)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Search)
  .use(VanImage)
  .use(Lazyload)
  .use(Loading)
  .use(Tab)
  .use(Tabs)
  .use(Tag)
  .use(List)
  .use(Notify)
  .use(RadioGroup)
  .use(Radio)
  .use(CountDown)
  .use(Form)
  .use(DropdownMenu)
  .use(DropdownItem)
  .use(AddressList)
  .use(NavBar)
  .use(Skeleton)

setSession('urlCount', 0)

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
  next()
})
router.afterEach((to, from) => {
  const urlCount = getSession('urlCount')
  setSession('urlCount', urlCount + 1)
  let { hash, pathname, origin, port } = location
  let { formattedAddress, position } = store.state
  if (!getSession('once')) {
    if (!!position.lat && formattedAddress === '定位失败' && hash !== '#/' && process.env.NODE_ENV === 'production' && to.fullPath !== from.fullPath) {
      setSession('once', 1)
      window.location.href = origin + pathname + to.href
    }
  } else {
    setSession('once', '')
  }
  let { name: currentPage, pageCode: pageName = '' } = to.meta
  if (!port && pageName) {
    aplus_queue.push({
      action: 'aplus.sendPV',
      arguments: [
        { is_auto: false },
        {
          page_name: pageName,
          page_title: currentPage
        }
      ]
    })
  }
})

app
  .use(store)
  .use(router)
  .mount('#app')

import Vconsole from 'vconsole'
const enableVconsole = process.env.VUE_APP_ENABLE_VCONSOLE === 'true'
if (enableVconsole) {
  const vConsole = new Vconsole()
  app.use(vConsole)

}
// const vConsole = new Vconsole()
// app.use(vConsole)
